














import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { WaitlistItem, Resources, Employees } from '../models'
const Speak = require('speak-tts').default // tslint:disable-line:no-var-requires

@Component
export default class FlashMessage extends Vue {
  protected speechInitialDelayPassed = false
  protected speak = new Speak()
  protected activeCounter: string = ''
  protected speechEngineInitialized = false

  @Prop() protected item: WaitlistItem // tslint:disable-line
  @Watch('item') onItemChange() {
    this.speakToMe()
  }

  mounted() {
    // Don't speak right away, wait till at least 1 cycle of updates
    setTimeout(() => {
      this.speechInitialDelayPassed = true
    }, 10000)
  }

  speakToMe() {
    if (this.item && this.speechInitialDelayPassed) {
      if (!this.speechEngineInitialized) {
        const voiceName: string = 'Google US English'
        const voices: any[] = window.speechSynthesis &&
          window.speechSynthesis.getVoices &&
          window.speechSynthesis.getVoices() ||
          []
        const voiceConfig: any = {
          voice: voiceName,
          // rate: 0.7,
        }
        if (!voices || !voices.length) { return }
        if (!voices.find((v) => v.name === voiceName)) {
          delete voiceConfig.voice
        }
        this.speak.init(voiceConfig).then((d: any) => {
          this.speechEngineInitialized = true
          document.getElementById('speak-button').click()
        })
      } else {
        document.getElementById('speak-button').click()
      }
    }
  }

  actuallySpeakToMeResource() {
    const { resource_ids } = this.item
    const resources = resource_ids ? resource_ids.map((id) => Resources.entitiesById[id]) : []
    const resource = resources.shift()
    const itemText = resource
      ? `${resource.name.replace(/0+([0-9])+/g, '$1')}`
      : 'the window'
    const text = `
      Now calling.
      ${this.item.ticket_number}.
      Please proceed to ${itemText}.
    `

    this.activeCounter = itemText
    this.speak.speak({ text })
  }

  actuallySpeakToMeEmployee() {
    const { employee_id } = this.item
    const employee = Employees.entitiesById[employee_id]
    const itemText = employee
      ? `${employee.name.replace(/0+([0-9])+/g, '$1')}`
      : 'the window'
    const text = `
      Now calling.
      ${this.item.ticket_number}.
      Please proceed to ${itemText}.
    `

    this.activeCounter = itemText
    this.speak.speak({ text })
  }

  protected beforeDestroy() {
    this.speak = null

    this.speechEngineInitialized = false
    this.speechInitialDelayPassed = false
    this.item = null
  }
}
